"use client";

import * as React from "react";
import { NavigationLink } from "./navigation-link";

type HeaderLinkProps = {
  href: string;
  /** Text used for analytics tracking (and as fallback content) */
  text?: string;
  /** Override the text sent in the navItemClick analytics event (defaults to text) */
  analyticsText?: string;
  /** Stable slug for the navItemClick event, so the identifier never keys on
   *  rendered copy. */
  analyticsId: string;
  /** Optional children content to render (if not provided, text will be rendered) */
  children?: React.ReactNode;
  external?: boolean;
  externalIconVisible?: boolean;
  suppressExternalIcon?: boolean;
  ariaLabel?: string;
  className?: string;
} & Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "children" | "className"
>;

export const HeaderLink = React.forwardRef<HTMLAnchorElement, HeaderLinkProps>(
  (
    {
      href,
      text,
      analyticsText,
      analyticsId,
      children,
      external = false,
      externalIconVisible = false,
      suppressExternalIcon = false,
      className,
      ariaLabel,
      ...rest
    },
    ref,
  ) => {
    return (
      <NavigationLink
        ref={ref}
        href={href}
        text={text}
        analyticsText={analyticsText}
        location="Main Nav"
        external={external}
        externalIconVisible={externalIconVisible}
        suppressExternalIcon={suppressExternalIcon}
        className={className}
        aria-label={ariaLabel}
        {...rest}
        analyticsId={analyticsId}
      >
        {children}
      </NavigationLink>
    );
  },
);

HeaderLink.displayName = "HeaderLink";
